module.exports = __webpack_public_path__ + "img/7.ee78e43b.jpg";